import * as actions from '../actions'

const defaultState = []

export default function services(state = defaultState, action) {
    switch (action.type) {
        case actions.GET_SERVICES_CONFIG:
            let newState = {}
            if (!action.error && action.payload && action.payload.data) {
                newState = action.payload.data
            }
            return newState
        default:
            return state
    }
}
